/** Base URL for the self-hosted OXN Sourcify server (API v1). */
export const getSourcifyServerUrl = (): string => {
  const configured = import.meta.env.REACT_APP_SOURCIFY_SERVER_URL
  if (configured) return configured.replace(/\/$/, '')
  // Proxied by explorer nginx in production.
  return '/sourcify'
}

export const getSourcifyChainId = (): string => String(import.meta.env.REACT_APP_EVM_CHAIN_ID || 186)

export type SourcifyCheckStatus = 'perfect' | 'partial' | false | string

/** Check whether an address is verified on our Sourcify instance. */
export async function checkSourcifyVerification(
  address_eth: string,
): Promise<'full' | 'partial' | undefined> {
  const url = `${getSourcifyServerUrl()}/check-by-addresses?addresses=${encodeURIComponent(
    address_eth,
  )}&chainIds=${encodeURIComponent(getSourcifyChainId())}`
  const response = await fetch(url)
  if (!response.ok) return undefined
  const data = (await response.json()) as Array<{ address?: string; status?: SourcifyCheckStatus }>
  const row = data.find(item => item.address?.toLowerCase() === address_eth.toLowerCase()) ?? data[0]
  if (!row || row.status === false || row.status === 'false') return undefined
  if (row.status === 'partial') return 'partial'
  if (row.status === 'perfect' || row.status === 'full') return 'full'
  // Some responses use "perfect" aliases; treat any truthy match as full.
  if (row.status) return 'full'
  return undefined
}
